import * as React from 'react';

/**
 * Question Mark help SVG for loading purposes
 *
 * @returns
 */
function XSVG(svgProps: SVGProps) {
	return (
		<svg viewBox="0 0 32 32" className={'icon icon-x ' + svgProps.class} focusable="false" aria-hidden="true">
			<path d="M8.469 2.824l20.702 20.702c1.56 1.56 1.56 4.088 0 5.648s-4.088 1.56-5.648 0l-20.702-20.702c-1.56-1.56-1.56-4.088 0-5.648s4.088-1.56 5.648 0z" />
			<path d="M29.176 8.472l-20.702 20.702c-1.56 1.56-4.088 1.56-5.648 0l0.002 0.002c-1.56-1.56-1.56-4.088 0-5.648l20.702-20.702c1.56-1.56 4.088-1.56 5.648 0l-0.002-0.002c1.56 1.56 1.56 4.088 0 5.648z" />
		</svg>
	);
}

XSVG.defaultProps = { class: '' };

export default XSVG;
